/**
 * <sort-disclosure> turns the sort-by <select> into a styled dropdown that
 * matches the filter panel, while keeping the original <select> in the DOM
 * (visually hidden) as the source of truth for the existing facets.js logic.
 *
 * Clicking an option updates the hidden <select> and dispatches a native
 * "input" event, which is exactly what facets.js already listens for on the
 * form — so sorting, the AJAX refresh and the URL/history update all keep
 * working without any changes to facets.js.
 *
 * This element is re-created from fresh server-rendered HTML after every
 * filter/sort request (Dawn replaces the ".sorting" block wholesale), so it
 * re-attaches itself automatically each time — no manual cleanup needed.
 */
class SortDisclosure extends HTMLElement {
  constructor() {
    super();
    this.select = document.getElementById(this.dataset.selectId) || this.querySelector('select');
    this.details = this.querySelector('details');
    this.addEventListener('click', this.onOptionClick.bind(this));
    this.addEventListener('keydown', this.onKeyDown.bind(this));
  }

  onOptionClick(event) {
    const button = event.target.closest('[data-sort-value]');
    if (!button || !this.select) return;

    this.selectValue(button.dataset.sortValue);
    if (this.details) this.details.removeAttribute('open');
  }

  onKeyDown(event) {
    if (event.key === 'Escape' && this.details && this.details.hasAttribute('open')) {
      this.details.removeAttribute('open');
      this.details.querySelector('summary')?.focus();
    }
  }

  selectValue(value) {
    if (!this.select || this.select.value === value) return;
    this.select.value = value;
    this.select.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

customElements.define('sort-disclosure', SortDisclosure);